// extracted by mini-css-extract-plugin
export default {"theme":"#3642FF"};